import React from 'react';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';
import { Calendar } from 'primereact/calendar';

export function PickDate(props) {
    // Ensure `iDate` is always valid; fallback to a default or current date
    const parsedDate = dayjs(props.iDate, 'DD/MM/YYYY');
    const validDate = parsedDate.isValid() ? parsedDate.toDate() : null;

    return (

                <Calendar
                    value={validDate}
                    onChange={(e) => {
                        if (e.value instanceof Date) {
                            props.setDate(e.value);
                        }
                    }}
                    dateFormat="dd/mm/yy"
                    selectionMode="single"
                    disabled={props.disable}
                    className=" h-2rem align-items-center justify-content-center mt-3 mb-2"


                />


    );
}


PickDate.propTypes = {
    iDate: PropTypes.object.isRequired,
    setDate: PropTypes.func.isRequired,
    disable: PropTypes.bool.isRequired,
};
